// export const apiUrl ='https://localhost:44342/api/v1.1/';
export const apiUrl = 'https://apimaznappsdev01.asemazeus2appdev01.appserviceenvironment.net/api/v1.1/';